import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const VideoPlayer = ({ url, title, onPiPChange = () => {} }) => {
  const [hasPlaybackError, setHasPlaybackError] = useState(false);

  useEffect(() => {
    setHasPlaybackError(false);
  }, [url]);

  useEffect(() => {
    onPiPChange(false);
  }, [onPiPChange, url]);

  const normalizeVideoUrl = (value) => {
    if (!value || typeof value !== 'string') {
      return '';
    }

    const trimmedValue = value.trim();
    if (!trimmedValue) {
      return '';
    }

    if (
      /^(https?:)?\/\//i.test(trimmedValue) ||
      trimmedValue.startsWith('blob:') ||
      trimmedValue.startsWith('data:')
    ) {
      return trimmedValue;
    }

    if (!API_BASE_URL) {
      return trimmedValue;
    }

    return `${API_BASE_URL.replace(/\/+$/, '')}/${trimmedValue.replace(
      /^\/+/,
      ''
    )}`;
  };

  const resolvedUrl = normalizeVideoUrl(url);
  const isPlayableUrl = ReactPlayer.canPlay(resolvedUrl);
  const isEmbeddableLink =
    /^https?:\/\//i.test(resolvedUrl) && !isPlayableUrl && !hasPlaybackError;

  if (!resolvedUrl) {
    return (
      <div className="rounded-lg border bg-gray-50 p-4 text-sm text-gray-700 dark:bg-navy-900 dark:text-gray-300">
        Video URL is not available.
      </div>
    );
  }

  if (hasPlaybackError) {
    return (
      <div className="rounded-lg border bg-gray-50 p-4 text-sm text-gray-700 dark:bg-navy-900 dark:text-gray-300">
        Unable to load this video in the player.
      </div>
    );
  }

  if (isEmbeddableLink) {
    return (
      <iframe
        src={resolvedUrl}
        title={title}
        width="100%"
        height="520"
        className="rounded-lg border-0"
        allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
        allowFullScreen
        onError={() => setHasPlaybackError(true)}
      />
    );
  }

  return (
    <div className="overflow-hidden rounded-lg dark:bg-navy-900">
      <ReactPlayer
        url={resolvedUrl}
        controls
        pip
        playing={false}
        playsinline
        width="100%"
        height="min(70vh, 520px)"
        onEnablePIP={() => onPiPChange(true)}
        onDisablePIP={() => onPiPChange(false)}
        onError={() => setHasPlaybackError(true)}
      />
    </div>
  );
};

export default VideoPlayer;
